var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"end"}},_vm._l((_vm.distros),function(distro){return _c('v-col',{key:distro.name,staticClass:"flex-grow-1",attrs:{"cols":"6","sm":"3"}},[_c('DevIcon',{attrs:{"name":distro.name,"icon":distro.icon,"href":distro.href}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }